










import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      value: 'string',
    };
  },
  watch: {
    value: function (value) {
      this.$emit('value', value);
    },
  },
  created() {
    this.value = this.$attrs.value;
  },
});
